import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { WebConfig } from '@ctt-babylon/public-api';
import { catchError, filter, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService, LoginResponse } from '../api/api.service';
import { RoutesService } from '../routes/routes.service';
import { TOKEN_KEY } from '../routes/transfer-keys';
import { SiteConfigService } from '../site-config/site-config.service';

@Injectable({
    providedIn: 'root',
})
export class InitializerService {
    platformId = inject(PLATFORM_ID);
    constructor(
        private readonly siteSvc: SiteConfigService,
        private readonly routesSvc: RoutesService,
        private readonly transferState: TransferState,
        private readonly apiService: ApiService
    ) {}

    loadSettings(): Promise<void> {
        return this.getAndManageGeneralConfig();
    }

    async configureRoutes(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.getAccessToken()
                .pipe(
                    tap((res) => {
                        environment.token = res.accessToken;
                        this.transferState.set(TOKEN_KEY, res.accessToken);
                    }),
                    switchMap(() =>
                        this.apiService.getRoutes().pipe(
                            filter(
                                (data) => data !== null && data !== undefined
                            ),
                            tap((data) => {
                                this.routesSvc.setSettingsRouter(
                                    (data as any).pages
                                );
                                resolve();
                            }),
                            catchError((err) => {
                                reject(err);
                                return throwError(() => err);
                            })
                        )
                    ),
                    catchError((err) => {
                        reject(err);
                        return throwError(() => err);
                    })
                )
                .subscribe();
        });
    }

    async getAndManageGeneralConfig(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.getAccessToken()
                .pipe(
                    tap((res) => {
                        environment.token = res.accessToken;
                    }),
                    switchMap(() =>
                        this.siteSvc.getGeneralConfig().pipe(
                            filter((body): body is WebConfig => body !== null),
                            tap((config) => {
                                this.siteSvc.setInitialLanguage(config);
                                this.routesSvc.setSettingsRouter(config.pages);

                                if (!this.siteSvc.cdnImagesInstant) {
                                    this.siteSvc.setCdnImages(config.cdn || '');
                                }
                                this.siteSvc.setWebConfig(config);
                                resolve();
                            }),
                            catchError((err: HttpErrorResponse) => {
                                reject(err);
                                return throwError(() => err);
                            })
                        )
                    )
                )
                .subscribe();
        });
    }

    getAccessToken() {
        return this.apiService.postAuthLogin().pipe(
            filter((res): res is LoginResponse => res !== null),
            catchError((err) => {
                console.error(
                    '[SSR Initializer] getAccessToken: Error CRÍTICO al obtener token:',
                    err
                );
                // En lugar de EMPTY, propaga el error para que el catchError de configureRoutes lo maneje.
                return throwError(() => `Fallo en getAccessToken: ${err}}`);
            })
        );
    }
}
